import type { ReactNode } from 'react';
import { Box, Stack } from '@rossum/ui/material';
import { NESTED_ROW_INDENT, ROW_MIN_HEIGHT } from '../constants';

type ActivityRowLayoutProps = {
  label: ReactNode;
  labelIcon?: ReactNode;
  icon?: ReactNode;
  value: ReactNode;
  secondary?: ReactNode;
  hasIndent?: boolean;
  dataCy: string;
};

export const ActivityRowLayout = ({
  label,
  labelIcon,
  icon,
  value,
  secondary,
  hasIndent = false,
  dataCy,
}: ActivityRowLayoutProps) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns:
        'minmax(0, 200px) 20px minmax(0, 1fr) minmax(0, 1fr)',
      alignItems: 'start',
      columnGap: 2,
      minHeight: ROW_MIN_HEIGHT,
      '& > *': {
        minWidth: 0,
        minHeight: ROW_MIN_HEIGHT,
        alignItems: 'center',
      },
    }}
    data-cy={dataCy}
  >
    <Stack
      direction="row"
      spacing={0.5}
      useFlexGap
      sx={{ pl: hasIndent ? NESTED_ROW_INDENT : 0 }}
    >
      {labelIcon ? (
        <Stack sx={{ color: 'text.secondary' }}>{labelIcon}</Stack>
      ) : null}
      {label}
    </Stack>
    <Stack sx={{ color: 'text.disabled' }}>{icon ?? null}</Stack>
    <Stack direction="row">{value}</Stack>
    <Stack direction="row" spacing={1} useFlexGap>
      {secondary}
    </Stack>
  </Box>
);
